import styled, {keyframes} from 'styled-components';

const fadeUp = keyframes`
    from {
        opacity: 0;
        margin-top: 100px;
    }
    to {
        opacity: 1;
        margin-top: 0px;
    }
`;

export const Background = styled.div`
    background: radial-gradient(ellipse at center, #294052 0%,#182531 100%);
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
`;

export const LoginContainer = styled.div`
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
`;

export const LoginModal = styled.div`
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.3);
    padding: 20px 40px;
    opacity: 0;
    margin-top: 100px;
    animation: ${fadeUp} 0.7s forwards 1;
`;

export const SubLink = styled.div`
	color: #2B68B2;
	font-size: 14px;
	cursor: pointer;
	margin-top: 5px;
`;